export default __webpack_public_path__ + "paddle_finance_hover2e299b.svg";